import { BrainCircuit, ScanLine, Sparkles } from 'lucide-react';
import Brand from './Brand';

export default function ProcessingView({ image, progress, phase }) {
  return (
    <div className="processing-page page-frame">
      <header className="simple-header"><Brand /></header>
      <main className="processing-main">
        <section className="processing-visual">
          <img src={image} alt="Restaurant being analyzed" />
          <div className="processing-grid" />
          <div className="processing-beam" />
          <span className="processing-badge"><ScanLine size={16} /> Live analysis</span>
        </section>
        <section className="processing-copy">
          <span className="eyebrow"><Sparkles size={16} /> Hybrid recognition</span>
          <h1>Finding the restaurant</h1>
          <p>{phase || 'Reading the sign and comparing your photo with local restaurant references.'}</p>
          <div className="progress-track"><span style={{ width: `${Math.round(progress * 100)}%` }} /></div>
          <div className="progress-meta"><strong>{Math.round(progress * 100)}%</strong><span>{phase}</span></div>
          <div className="analysis-steps">
            <span className={progress > 0.15 ? 'done' : ''}><BrainCircuit /> Arabic + English OCR</span>
            <span className={progress > 0.52 ? 'done' : ''}><ScanLine /> Visual fingerprint matching</span>
            <span className={progress > 0.86 ? 'done' : ''}><Sparkles /> Confidence ranking</span>
          </div>
        </section>
      </main>
    </div>
  );
}
